import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-950">
      <Header />

      <main>
        <HeroSection />
        <CardsSection />
        <TopicsSection />
        <IndexSection />
        <AppSection />
        <CommentsSection />
        <FaqSection />
        <ContactSection />
        <MediaSection />
        <CarouselSection />
        <RankingSection />
        <UpdatesSection />
        <FeaturesSection />
        <AboutSection />
      </main>

      <Footer />
    </div>
  );
}